import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RequireAuth from "../features/auth/components/RequireAuth";
import RequirePermission from "../features/auth/components/RequirePermission";
import RequireReportDesigner from "../features/auth/components/RequireReportDesigner";
import LoginPage from "../features/auth/pages/LoginPage";
import DashboardPage from "../features/dashboard/pages/DashboardPage";
import ReportsPage from "../features/reports/pages/ReportsPage";
import UsersPage from "../features/staff/pages/UsersPage";
import SettingsPage from "../features/settings/pages/SettingsPage";
import TargetsPage from "../features/targets/pages/TargetsPage";
import TargetsSettingsPage from "../features/targets/pages/TargetsSettingsPage";
import CommissionsSettingsPage from "../features/commissions/pages/CommissionsSettingsPage";
import PoolPage from "../features/notifications/pages/PoolPage";
import AuditPage from "../features/audit/pages/AuditPage";
import ReportDesignerPage from "../features/reports/pages/ReportDesignerPage";
import { ROUTE_PERMISSIONS } from "../shared/permissions";

function Guarded({ path, children }) {
  const permission = ROUTE_PERMISSIONS[path];
  return (
    <RequireAuth>
      <RequirePermission permission={permission}>
        {children}
      </RequirePermission>
    </RequireAuth>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <Guarded path="/">
            <DashboardPage />
          </Guarded>
        }
      />
      <Route
        path="/reports"
        element={
          <Guarded path="/reports">
            <ReportsPage />
          </Guarded>
        }
      />
      <Route
        path="/users"
        element={
          <Guarded path="/users">
            <UsersPage />
          </Guarded>
        }
      />
      <Route
        path="/settings"
        element={
          <Guarded path="/settings">
            <SettingsPage />
          </Guarded>
        }
      />
      <Route
        path="/targets"
        element={
          <Guarded path="/targets">
            <TargetsPage />
          </Guarded>
        }
      />
      <Route
        path="/targets/settings"
        element={
          <Guarded path="/targets/settings">
            <TargetsSettingsPage />
          </Guarded>
        }
      />
      <Route
        path="/commissions"
        element={
          <Guarded path="/commissions">
            <CommissionsSettingsPage />
          </Guarded>
        }
      />
      <Route
        path="/pool"
        element={
          <Guarded path="/pool">
            <PoolPage />
          </Guarded>
        }
      />
      <Route
        path="/audit"
        element={
          <Guarded path="/audit">
            <AuditPage />
          </Guarded>
        }
      />
      <Route
        path="/working-calendar"
        element={
          <Guarded path="/working-calendar">
            <Navigate to="/settings?tab=working-calendar" replace />
          </Guarded>
        }
      />
      <Route
        path="/reports/designer"
        element={
          <RequireReportDesigner>
            <ReportDesignerPage />
          </RequireReportDesigner>
        }
      />
      <Route path="*" element={<RequireAuth><Navigate to="/" replace /></RequireAuth>} />
    </Routes>
  );
}
